import React, { useEffect, useState, useRef, Fragment } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { createClearingEvent,getAllClearingEvents } from '../../../actions/ssmActions';
import { getBranchList } from '../../../actions/commonAction';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { TextField } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useTranslation } from 'react-i18next';
import { showAlertSnackbar } from '../../../reducers/uiSlice';
function ConfirmationDialogRaw(props) {
    const { onClose, value: valueProp, open, ...other } = props;
    const radioGroupRef = useRef(null);
    const dispatch = useDispatch();
    const {t} = useTranslation('storageScan');
    
    const [value, setValue] = useState(valueProp);
    const [branches, setBranches] = useState([]);
    const [lastTno, setLastTno] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (radioGroupRef.current != null) {
            radioGroupRef.current.focus();
        }
    });
    useEffect(() => {
        dispatch(getBranchList()).then((branches)=>{
            setBranches(branches);
        })
    }, [])

    const handleEntering = () => {
        if (radioGroupRef.current != null) {
            radioGroupRef.current.focus();
        }
    };
    const handleCancel = () => {
        onClose();
    };
    const handleOk = () => {
        setLoading(true);
        dispatch(createClearingEvent(value, lastTno))
        .then((res) => {
            dispatch(getAllClearingEvents(value))
            .then(() => {
                setLoading(false);
            })
        })
        .catch(() => {
            setErrorMsg(t('repeat_event'));
            dispatch(showAlertSnackbar({message: t('repeat_event'), type: 'error'}))
            setLoading(false);
        })
        onClose(value);
    };
    const handleChange = (event) => {
        setValue(event.target.value);
    };

    return (
        <Fragment>
            {   loading && 
                <CircularProgress
                    size={30}
                    style={{ position: 'absolute', top: 90 }}
                /> 
            }
            <Dialog
                disableBackdropClick
                disableEscapeKeyDown
                maxWidth="xs"
                onEntering={handleEntering}
                aria-labelledby="confirmation-dialog-title"
                open={open}
                {...other}
            >
                <DialogTitle id="confirmation-dialog-title">{t('create_event')}</DialogTitle>
                <DialogContent dividers style={{ display: 'flex'}}>
                    <TextField
                        onChange={(e)=>{setLastTno(e.target.value)}}
                        id="outlined-search"
                        label="Last Storage No"
                        variant="outlined"
                        style={{ marginRight: 50 }}
                    />
                    <Select
                        defaultValue={`1`}
                        displayEmpty
                        onChange={handleChange}
                    >
                        {
                            branches.map((branch, index) => {
                                return <MenuItem key={index} value={branch.id}>{branch.name}</MenuItem>
                            })
                        }
                    </Select>
                </DialogContent>
                <DialogActions>
                <Button autoFocus onClick={handleCancel} color="primary">
                    {t('cancel')}
                </Button>
                <Button onClick={handleOk} color="primary">
                    {t('ok')}
                </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
        
    );
}

ConfirmationDialogRaw.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    value: PropTypes.string.isRequired,
};

const useStyles = makeStyles((theme) => ({
    margin: {
        margin: theme.spacing(1),
    },
}));

function CreateEvent() {
    const classes = useStyles();
    const {t} = useTranslation('storageScan');
    
    const [open, setOpen] = useState(false);
    const [value, setValue] = useState(1);

    const handleClickListItem = () => {
        setOpen(true);
    };
    const handleClose = (newValue) => {
        setOpen(false);
        if (newValue) {
            setValue(newValue);
        }
    };
    
    return (
        <div style={{ height: 'fit-content' }}>
            <Button variant="contained" color="primary" className={classes.margin} onClick={handleClickListItem}>
            {t('create_event')}
            </Button>
            <ConfirmationDialogRaw
                classes={{
                    paper: classes.paper,
                }}
                id="ringtone-menu"
                keepMounted
                open={open}
                onClose={handleClose}
                value={value}
            />
        </div>
    );
}

export default CreateEvent;
